import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { EditorService } from '../../../editor.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-typhography',
  templateUrl: './typhography.component.html',
  styleUrls: ['./typhography.component.css']
})
export class TyphographyComponent implements OnInit {
  @Input() data: any;
  fontFamily = 'Arial';
  fontSize = '18'
  isInitial = true;
  isFontColor = true;
  isFontBackColor = true;
  isInitialsize = true;
  showFontSize = 5;
  SelectedTextColor = 'red';
  SelectedbackColor = 'yellow';
  showdata = 6;
  cardObj;
  SelectedTextOpt = undefined;
  SelectedFstyleOpt = undefined;
  SelectedScriptOpt = 5;
  SelectedStyleOpt;
  selectedColorOpt;
  SelectedDirectionOpt = 0;
  tDirection = [{
    type: '1',
    name: 'icon-TextDirectionL-New',
    dir: 'LTR'
  },
  {
    type: '2',
    name: 'icon-TextDirectionR-New',
    dir: 'RTL'
  }
  ];
  fontfamilystyle = [
    "Arial",
    "Georgia",
    "Impact",
    "Times New Roman",
    "Verdana",
    "JF-Flat-Regular",
    "JF-Flat-Light",
    "JF-Flat-Medium",
    "Amiri-Bold",
    "Amiri-Regular",
    "Amiri-BoldSlanted",
    "Amiri-Slanted",
    "Aref_Ruqaa-Bold",
    "Aref_Ruqaa-Regular",
    "Cairo-Bold",
    "Cairo-ExtraLight",
    "Cairo-Light",
    "Cairo-Regular",
    "Cairo-Black",
    "Cairo-SemiBold",
    "Changa-Bold",
    "Changa-ExtraBold",
    "Changa-ExtraLight",
    "Changa-Light",
    "Changa-SemiBold",
    "Changa-Regular",
    "Changa-Medium",
    "Katibeh-Regular",
    "Lateef-Regular",
    "Mirza-Bold",
    "Mirza-Medium",
    "Mirza-Regular",
    "Mirza-SemiBold",
    "Rakkas-Regular",
    "Reem_Kufi-Regular",
    "Scheherazade-Bold",
    "Scheherazade-Regular"
  ];

  fontfamilystyle1 = [{
    "type": "Arial",
    "style": "Arial,Helvetica,sans-serif"
  },
  {
    "type": "Georgia",
    "style": "Georgia,serif"
  },
  {
    "type": "Impact",
    "style": "Impact,Charcoal,sans-serif"
  },
  {
    "type": "Times New Roman",
    "style": "Times New Roman,Times,serif"
  },
  {
    "type": "Verdana",
    "style": "Verdana,Geneva,sans-serif"
  },
  {
    "type": "JF-Flat-Regular",
    "style": "JF-Flat-Regular"
  }, {
    "type": "JF-Flat-Light",
    "style": "JF-Flat-Light"
  }, {
    "type": "JF-Flat-Medium",
    "style": "JF-Flat-Medium"
  },
  {
    "type": "Amiri-Bold",
    "style": "Amiri-Bold"
  },
  {
    "type": "Amiri-Regular",
    "style": "Amiri-Regular"
  },
  {
    "type": "Amiri-BoldSlanted",
    "style": "Amiri-BoldSlanted"
  },
  {
    "type": "Amiri-Slanted",
    "style": "Amiri-Slanted"
  },
  {
    "type": "Aref_Ruqaa-Bold",
    "style": "Aref_Ruqaa-Bold"
  },
  {
    "type": "Aref_Ruqaa-Regular",
    "style": "Aref_Ruqaa-Regular"
  },
  {
    "type": "Cairo-Bold",
    "style": "Cairo-Bold"
  },
  {
    "type": "Cairo-ExtraLight",
    "style": "Cairo-ExtraLight"
  },
  {
    "type": "Cairo-Light",
    "style": "Cairo-Light"
  },
  {
    "type": "Cairo-Regular",
    "style": "Cairo-Regular"
  },
  {
    "type": "Cairo-Black",
    "style": "Cairo-Black"
  },
  {
    "type": "Cairo-SemiBold",
    "style": "Cairo-SemiBold"
  },
  {
    "type": "Changa-Bold",
    "style": "Changa-Bold"
  },
  {
    "type": "Changa-ExtraBold",
    "style": "Changa-ExtraBold"
  },
  {
    "type": "Changa-ExtraLight",
    "style": "Changa-ExtraLight"
  },
  {
    "type": "Changa-Light",
    "style": "Changa-Light"
  },
  {
    "type": "Changa-SemiBold",
    "style": "Changa-SemiBold"
  },
  {
    "type": "Changa-Regular",
    "style": "Changa-Regular"
  },
  {
    "type": "Changa-Medium",
    "style": "Changa-Medium"
  },
  {
    "type": "Katibeh-Regular",
    "style": "Katibeh-Regular"
  },
  {
    "type": "Lateef-Regular",
    "style": "Lateef-Regular"
  },
  {
    "type": "Mirza-Bold",
    "style": "Mirza-Bold"
  },
  {
    "type": "Mirza-Medium",
    "style": "Mirza-Medium"
  },
  {
    "type": "Mirza-Regular",
    "style": "Mirza-Regular"
  },
  {
    "type": "Mirza-SemiBold",
    "style": "Mirza-SemiBold"
  },
  {
    "type": "Rakkas-Regular",
    "style": "Rakkas-Regular"
  },
  {
    "type": "Reem_Kufi-Regular",
    "style": "Reem_Kufi-Regular"
  },
  {
    "type": "Scheherazade-Bold",
    "style": "Scheherazade-Bold"
  },
  {
    "type": "Scheherazade-Regular",
    "style": "Scheherazade-Regular"
  }
  ];

  fontSizestyle = [6, 8, 10, 12, 14, 18, 24, 30, 36, 40, 44];
  fontStyle1 = [{
    'icon': 'icon-Bold-2',
    'state': 'Bold'
  }, {
    'icon': 'icon-Italic-2',
    'state': 'Italic'
  }, {
    'icon': 'icon-Underline-2',
    'state': 'Underline'
  }, {
    'icon': 'icon-StrikeThrough',
    'state': 'strikeThrough'
  }];
  scriptStyle = [{
    'icon': ' icon-SuperScript',
    'state': 'superscript'
  }, {
    'icon': 'icon-SubScript',
    'state': 'subscript'
  }];
  styleList = [
    {
      'icon': 'icon-OrderedList',
      'state': 'insertOrderedList'
    }, {
      'icon': 'icon-List',
      'state': 'insertUnorderedList'
    }];

  fontStyle2 = [
    {
      'icon': 'icon-Left',
      'state': 'justifyLeft'
    },
    {
      'icon': 'icon-Center',
      'state': 'justifyCenter'
    },
    {
      'icon': 'icon-Right',
      'state': 'justifyRight'
    },
    {
      'icon': 'icon-Justify_line',
      'state': 'justifyFull'
    }];
  constructor(private ele: ElementRef, private editorService: EditorService) { }

  ngOnInit() {

    let cardData = this.editorService.editorCardObj;
    let cardCData = this.editorService.textInlineData;

    this.initializeCard(cardData, cardCData);

  }

  initializeCard(cardObj, cardCData) {
    if (cardObj) {

      if (cardObj.foreColor)
        this.SelectedTextColor = cardObj.foreColor;
      if (cardObj.backColor)
        this.SelectedbackColor = cardObj.backColor;
      if (cardObj.fontName)
        this.fontFamily = cardObj.fontName
      if (cardObj.fontSize)
        this.fontSize = cardObj.fontSize

      if (cardCData && cardCData.direction == "rtl") {
        this.SelectedDirectionOpt = 1;
      } else {
        this.SelectedDirectionOpt = 0;
      }
      setTimeout(() => {
        if (cardObj.bold == "true") {
          this.ele.nativeElement.querySelector('.fontStyleDiv0').style.color = '#0085FE';
        }
        if (cardObj.italic == "true") {
          this.ele.nativeElement.querySelector('.fontStyleDiv1').style.color = '#0085FE';
        }
        if (cardObj.underline == "true") {
          this.ele.nativeElement.querySelector('.fontStyleDiv2').style.color = '#0085FE';
        }
        if (cardObj.strikeThrough == "true") {
          this.ele.nativeElement.querySelector('.fontStyleDiv3').style.color = '#0085FE';
        }

      }, 0);

      if (cardObj.justifyLeft == "true") {
        this.SelectedTextOpt = 0;
      } else if (cardObj.justifyCenter == "true") {
        this.SelectedTextOpt = 1;
      } else if (cardObj.justifyRight == "true") {
        this.SelectedTextOpt = 2;
      } else if (cardObj.justifyFull == "true") {
        this.SelectedTextOpt = 3;
      }
      if (cardObj.orderedList == "true") {
        this.SelectedStyleOpt = 0;
      } else if (cardObj.unOrderedList == "true") {
        this.SelectedStyleOpt = 1;
      }
      if (cardObj.superscript == "true") {
        this.SelectedScriptOpt = 0;
      } if (cardObj.subscript == "true") {
        this.SelectedScriptOpt = 1;
      }

    }
  }

  updateSelFontFamily() {
    let index = _.indexOf(_.map(this.fontfamilystyle), this.fontFamily);
    this.showdata = index;
  }
  updateSelFontSize() {
    var fontS = parseInt(this.fontSize);
    let index = _.indexOf(_.map(this.fontSizestyle), fontS);
    this.showFontSize = index;
  }

  selectColorType(ind) {
    this.selectedColorOpt = ind;
    let layer = this.editorService.getIframeReference();
    layer.selectColorType(ind);
  }
  openFontColor(ind) {
    document.getElementsByClassName("globalpopup")[0]['style'].height = "200px";
    document.getElementsByClassName("globalpopup")[0]['style'].width = "300px";
    document.getElementsByClassName("globalpopup")[0]['style'].transition = "all .5s linear";
    this.selectColorType(ind);
  }

  addMediaToContent() {
    let layer = this.editorService.getIframeReference();
    let mediaData = {
      'icon': "icon-Image",
      'iconText': "I",
      'imagePath': "library/assets/media/image.png",
      'name': "Image",
      'toolTip': "PROP_PARAGRAPH_IMAGE",
      'type': "Media",
      'url': "",
      'urlLink': "components/general/text/templates/lqd.imagewithcomment.tmpl.html"
    }
    layer.addMediaToContent(mediaData);
  }

  currentFont
  changeFontFamily(font, ind) {
    this.fontFamily = font.type;
    this.currentFont = font;
    let layer = this.editorService.getIframeReference();
    layer.changeFontFamily(this.fontFamily);
  }
  changeFontSize(font, ind) {
    this.fontSize = font;
    this.showFontSize = ind;
    let layer = this.editorService.getIframeReference();
    layer.changeFontSize(this.fontSize);
  }

  applyFontStyle(fStyleObj, evt) {


    //  this.selectFstyle
    let layer = this.editorService.getIframeReference();

    let fsObj = {
      'type': fStyleObj.state
    }
    layer.applyFontStyle(fsObj);
    //if (data) {
    if (evt.currentTarget.style.color == '') {
      evt.currentTarget.style.color = "#0085FE";
    } else {
      evt.currentTarget.style.color = '';
    }
    //  }
  }
  applyMathStyle(mathStyle, ind) {
    let layer = this.editorService.getIframeReference();
    let mStyle = {
      'type': mathStyle.state
    }
    layer.applyMathStyle(mStyle, ind);
  }
  applyTextIndent(tIndent) {
    let layer = this.editorService.getIframeReference();
    let indStyle = {
      'type': tIndent.state
    }
    layer.applyTextIndent(indStyle);
  }

  applyBulletStyle(bStyle) {
    let layer = this.editorService.getIframeReference();
    let bulletStyle = {
      'type': bStyle.state
    }
    layer.applyBulletStyle(bulletStyle);
  }
  changeColor(clr) {
    let layer = this.editorService.getIframeReference();
    layer.changeColor();
  }
  changeTextColor(color) {
    this.SelectedTextColor = color;
    let layer = this.editorService.getIframeReference();
    layer.changeColor(color);
  }
  changeBackColor(color) {
    this.SelectedbackColor = color;
    let layer = this.editorService.getIframeReference();
    layer.changeColor(color);
  }
  resetColor(opt) {
    this.selectColorType(opt);
    if (this.selectedColorOpt == 0) {
      this.SelectedTextColor = 'rgb(51, 51, 51)';
    } else {
      this.SelectedbackColor = 'rgb(255, 255, 255)';
    }
    let layer = this.editorService.getIframeReference();
    layer.clearColor();
  }
  //For Reseting All typography Style
  resetAllStyle() {
    this.SelectedScriptOpt = 5;
    this.SelectedTextOpt = '';
    this.SelectedStyleOpt = '';
    this.SelectedTextColor = 'rgb(51, 51, 51)';
    this.SelectedbackColor = 'rgb(255, 255, 255)';
    this.SelectedDirectionOpt = 0;
    for (let i = 0; i < 4; i++) {
      this.ele.nativeElement.querySelector('.fontStyleDiv' + i).style.color = '';
    }
    let layer = this.editorService.getIframeReference();
    layer.removeStyles();
  }
  loadMainContainer() {
    document.getElementsByClassName("globalpopup")[0]['style'].height = "350px";
    document.getElementsByClassName("globalpopup")[0]['style'].width = "300px";
    document.getElementsByClassName("globalpopup")[0]['style'].transition = "all .5s linear";
  }
  changeTextDirection(value) {
    this.SelectedDirectionOpt = value;
    let layer = this.editorService.getIframeReference();
    layer.directionChange(value);
  }



}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/typhography/typhography.component.ts